module.exports = __webpack_public_path__ + "img/283.59defcf8.png";